import { FC } from "react";
import { BuscarComponent } from "../../../../shared/providers/ListView/BuscarComponent";
import { AuditoriaPropiedadTHeaderToolbar } from "./AuditoriaPropiedadTHeaderToolbar";

export const AuditoriaPropiedadTHeader: FC = () => {
    
    return (
        <div className='card-header border-0 py-4'>
            <BuscarComponent placeholder="Buscar" />
            <div className='card-toolbar'>
                <AuditoriaPropiedadTHeaderToolbar />
            </div>
        </div>
    )
}